import React, {useContext} from 'react';
import {Pie} from 'react-chartjs-2';
import {Doughnut} from 'react-chartjs-2';
import {TxnContext} from './TransactionContext';

export default function PieExample() {

    const [dummyTransaction] = useContext(TxnContext);

    const data = {
        labels: [
            'Education',
            'Shopping',
            'Food',
            'Transfer'
        ],
        datasets: [{
            data: [
                dummyTransaction.filter(txn => txn.category === 'education' && txn.type === "expense").reduce((acc,init) => acc+init.amount, 0),
                dummyTransaction.filter(txn => txn.category === 'shopping' && txn.type === "expense").reduce((acc,init) => acc+init.amount , 0),
                dummyTransaction.filter(txn => txn.category === 'food' && txn.type === "expense").reduce((acc,init) => acc+init.amount , 0),
                dummyTransaction.filter(txn => txn.category === 'transfer' && txn.type === "expense").reduce((acc,init) => acc+init.amount , 0)
                
            ],
            backgroundColor: [
            '#FF6384',
            '#36A2EB',
            '#FFCE56',
            '#2e8b57'
            ],
            hoverBackgroundColor: [
            '#FF6323',
            '#36A2AA',
            '#FFCE05',
            '#2e8b569f'
            ]
        }]
    };

    return (
      <div>
        <h2><center>Expenditure for each category</center></h2>
        <Pie data={data} />
      </div>
    );
};


export const DoughnutExample = () =>{

    const [dummyTransaction] = useContext(TxnContext);

    const data = {
        labels: [
            'Education',
            'Shopping',
            'Food',
            'Transfer'
        ],
        datasets: [{
            data: [
                dummyTransaction.filter(txn => txn.category === 'education' && txn.type === "income").reduce((acc,init) => acc+init.amount, 0),
                dummyTransaction.filter(txn => txn.category === 'shopping' && txn.type === "income").reduce((acc,init) => acc+init.amount , 0),
                dummyTransaction.filter(txn => txn.category === 'food' && txn.type === "income").reduce((acc,init) => acc+init.amount , 0),
                dummyTransaction.filter(txn => txn.category === 'transfer' && txn.type === "income").reduce((acc,init) => acc+init.amount , 0)
                
            ],
            backgroundColor: [
            '#FF6384',
            '#36A2EB',
            '#FFCE56',
            '#2e8b57'
            ],
            hoverBackgroundColor: [
            '#FF6384',
            '#36A2EB',
            '#FFCE56',
            '#2e8b569f'
            ]
        }]
    };

    return (
        <div>
        <h2><center>Income via each category</center></h2>
        <Doughnut data={data} />
        </div>
    );
}